import React from "react";
import { BaseComponent } from "../base/BaseComponent";
import { IExcercise } from "../../domain/exercise/IExcercise";

interface IExerciseSelectionItemProps
{
    exercise: IExcercise;
    onSelect: Function;
}

export class ExerciseSelectionItem extends BaseComponent<IExerciseSelectionItemProps, {}> {
    render() {
        if(!this.props.exercise)
            return;

        return <div className="button-wrapper">
                <button type="button" className="selector" onClick={() => this.props.onSelect()}>{this.props.exercise.title}</button>
            </div>;
    }
}
